<script>
import FlyerBlock from "@/components/block/FlyerBlock.vue";
import {mapGetters} from "vuex";

export default {
	name: "ItemHighlight",
	props: {
		products: {
			type: Array,
			default: () => []
		},
		block: {
			type: FlyerBlock
		}
	},
	computed: {
		...mapGetters('shoppingList', ['shoppingListSKUs']),
		...mapGetters('config', ['features']),
		filteredProducts() {
			const skus = this.shoppingListSKUs;
			return this?.products?.filter((prod) => {
				return skus.includes(prod.sku);
			}) || [];
		},
		regions() {
			if (this.filteredProducts.length > 0 && this?.products?.length === 1) {
				return [{
					top: 0,
					left: 0,
					width: this?.block?.width,
					height: this?.block?.height
				}]
			}
			return this.filteredProducts.map((prod) => {
				return this.getRegionDim(prod.clickRegions.reduce((maxRegion, region) => {
					const a1 = maxRegion.width * maxRegion.height;
					const a2 = region.width * region.height;
					return a1 > a2 ? maxRegion : region;
				}));
			})
		},
		color() {
			return this.features?.shoppingList?.highlight?.color || '#22A84A';
		}
	},
	methods: {
		getRegionDim(r) {
			const height = this?.block?.height;
			const width = this?.block?.width;
			return {
				top: height * (r.top / 100),
				left: width * (r.left / 100),
				width: width * (r.width / 100),
				height: height * (r.height / 100)
			}
		}
	}
}
</script>

<template>
	<div class="">
		<!--img
						v-for="(region, index) in regions"
						 :key="index"
						 src="/images/icon-ProductHighlight_Vector.svg"
						:style="`top:${region.top}px; left:${region.left}px; width:${region.width}px; height:${region.height}px`"
						class="highlight-overlay"
				 alt=""/ -->
		<svg
				v-for="(region, index) in regions"
				:key="index"
				:style="`top:${region.top}px; left:${region.left}px; width:${region.width}px; height:${region.height}px`"
				class="highlight-overlay"
				height="317px" preserveAspectRatio="none" version="1.1" viewBox="0 0 185 317" width="185px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<title>4EA2BA65-5A9D-4A29-962C-E0BA103B2533</title>
			<g id="R2---Desktop-wireframes" fill="none" fill-opacity="0.85" fill-rule="evenodd" stroke="none" stroke-width="1">
				<g id="raddar_R2_PDP_2.0_ShoppingList_Alert" :fill="color" transform="translate(-711, -188)">
					<path id="icon-ProductHighlight_Vector"
					      d="M889.986784,347.110681 C889.887083,364.37329 888.364957,381.702183 885.176653,397.658257 C866.493891,489.189337 805.416556,505.89074 764.494437,477.22578 C741.138855,461.343355 719.626145,428.492918 717.263125,374.163463 C713.604346,299.270446 748.72855,236.950802 783.617161,210.556443 C818.292888,206.236924 861.929642,226.536821 882.023831,290.032642 C887.307275,307.044107 890.222021,326.911684 889.986784,347.110681 M895.978702,342.106329 C895.717631,320.883141 892.36958,299.855231 886.882515,282.186993 C869.310713,226.733907 836.937279,202.723567 805.930935,198.002125 C807.654,197.508752 809.353074,197.127811 811.021455,196.86744 C813.791977,196.371848 813.621575,187.980064 810.826005,188 C802.784331,188.946099 794.462183,192.248815 786.212711,197.505793 C784.7486,197.653731 783.286606,197.839393 781.855305,198.080532 C759.123835,202.446923 737.043277,225.292991 722.081121,261.582186 C719.972448,266.862094 718.035941,272.487437 716.365796,278.512953 C715.793911,280.580387 716.105079,283.24623 717.080565,284.514058 C718.081805,285.818872 719.404091,285.148712 720.010198,283.028761 C729.638756,252.347156 745.126581,230.358388 761.958919,218.838455 C748.066446,234.590895 735.550942,255.351777 726.455814,278.837677 C708.908003,323.48685 704.927032,385.928528 721.694808,434.157061 C733.581978,467.910599 752.598839,486.878472 771.584655,496.889438 C814.294008,519.446287 872.068887,497.010007 890.785165,403.552384 C894.581975,384.127383 896.208726,363.039558 895.978702,342.106329"></path>
				</g>
			</g>
		</svg>
	</div>
</template>

<style lang="scss" scoped>

.highlight-overlay {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 99999;

  svg {
	position: absolute;
  }
}
</style>
